export const chemicalRelationsTableHeaders = [
  {
    title: "Drug",
    class: "tw-text-left",
    key: "1",
  },
  {
    title: "Association",
    class: "tw-text-center",
    key: "2",
  },
  {
    title: "Significant",
    class: "tw-text-center",
    key: "3",
  },
  {
    title: "Drug Variant Relation",
    class: "tw-text-center",
    key: "4",
  },
  {
    title: "Pharmacodynamic",
    class: "tw-text-center",
    key: "5",
  },
  {
    title: "Pharmacokinetic",
    class: "tw-text-center",
    key: "6",
  },
  {
    title: "Publications",
    class: "tw-text-center",
    key: "7",
  },
  {
    title: "Annotation ID",
    class: "tw-text-center",
    key: "8",
  },
  {
    title: "Curator notes",
    class: "tw-text-center",
    key: "9",
  },
];

export const chemicalRelationsGeneTableHeaders = [
  {
    title: "Drug",
    class: "tw-text-left",
    key: "1",
  },
  {
    title: "Association",
    class: "tw-text-center",
    key: "2",
  },
  {
    title: "Pharmacodynamic",
    class: "tw-text-center",
    key: "3",
  },
  {
    title: "Pharmacokinetic",
    class: "tw-text-center",
    key: "4",
  },
  {
    title: "Publications",
    class: "tw-text-center",
    key: "5",
  },
];
